export const Msg = ({ closeToast, toastProps }) => (
  <div className="flex flex-row text-xs gap-x-2">
    You just earned {toastProps.points} point{toastProps.points > 1 ? 's' : ''}. 
    <img src="/SVG/pic-bianco.svg" alt="bc logo" className="h-[20px]"/>
  </div>
);